import { merge as _merge } from 'rxjs/operators/merge';
import { mergeMap as _mergeMap } from 'rxjs/operators/mergeMap';
import { switchMap as _switchMap } from 'rxjs/operators/switchMap';
import { filter as _filter } from 'rxjs/operators/filter';
import { map as _map } from 'rxjs/operators/map';
import { catchError as _catchError } from 'rxjs/operators/catchError';
import { ignoreElements as _ignoreElements } from 'rxjs/operators/ignoreElements';
import { startWith as _startWith } from 'rxjs/operators/startWith';
import { tap as _tap } from 'rxjs/operators/tap';
import { debounceTime as _debounceTime } from 'rxjs/operators/debounceTime';
export const merge = _merge;
export const mergeMap = _mergeMap;
export const switchMap = _switchMap;
export const filter = _filter;
export const map = _map;
export const catchError = _catchError;
export const ignoreElements = _ignoreElements;
export const tap = _tap;
export const startWith = _startWith;
export const debounceTime = _debounceTime;